import { ajax } from 'rxjs/ajax'
import { XHR } from '../helpers/xhr'

const protocol = (process.env.NODE_ENV === 'test') ? 'http:' : ''

const getURL = (path) => {
  const basePath = __PRODUCTION__
    ? `https://${window.location.host}`
    : `${protocol}//${window.location.host || window.location.href}`

  if (path.charAt(0) === '/') {
    return `${basePath}${path}`
  } else {
    return `${basePath}${__PRODUCTION__ ? '/p0/api/' : '/api/'}${path}`
  }
}

export const callPlanet = (path, params, headers) => (
  ajax({
    body: params || null,
    createXHR: () => new XHR(),
    crossDomain: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers
    },
    method: (params ? 'POST' : 'GET'),
    responseType: 'json',
    url: getURL(path),
    withCredentials: true
  })
)

export * from './reviews'
